import { useState } from "react";
import { useTranslation } from "react-i18next";
import UtilMethods from "../../util/UtilMethods";
import { sendEmail } from "../../services/EmailSender";
import { updateSubscriptions } from "../../services/AdminServices";
import { FaBell, FaUser, FaEnvelope, FaMap, FaLanguage } from "react-icons/fa";
import { REGIONS } from "../common/Constants"


export default function SubscriptionForm() {
  const { t, i18n } = useTranslation("labels");

  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [status, setStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    const subscriptions = {
      name,
      phone,
      email,
      regions: selectedRegions,
      lang: i18n.language,
      createdAt: new Date().toISOString(),
      status: "active",
      unSubscribeURL: `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`,
    };
    console.log("Submitting subscription form", subscriptions);

    e.preventDefault();

    if (!UtilMethods.validateEmail(email)) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (selectedRegions.length === 0) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else if (!name) {
      setStatus("error");
      setErrorMessage(t("subscription.error"));
      return;
    } else { setStatus(null); }


    try {
      await updateSubscriptions(subscriptions);
      subscriptions.unSubscribeURL = `${process.env.REACT_APP_URL}/unsubscribe/${encodeURIComponent(email)}`;
     // sendEmail(subscriptions);
      console.log("Subscription form updated successfully");
    } catch (error) {
      console.error("Error updating subscription form", error);
      setStatus("error");
      setErrorMessage(t("subscription.apiError"));
    }

    setStatus("success");
    setName("");
    setPhone("");
    setEmail("");
    setSelectedRegions([]);
  };

  return (
    <section className="mrc-wrapper">
      <div className="mrc-left">
        <h1 >{t("subscription.title")}</h1>
        <p>{t("subscription.subtitle")}</p>
      </div>

      <form className="mrc-form" onSubmit={handleSubmit}>
        <div className="input-with-icon">
          <span className="input-icon">
            <FaUser />
          </span>

          <input
            placeholder={t("subscription.name")}
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div className="input-with-icon">
          <span className="input-icon">
            <FaEnvelope />
          </span>
          <input
            placeholder={t("subscription.email")}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="region-box">


          <div className="region-options">
            <span className="input-icon">
              <FaMap />
              {" "}{t("subscription.region")}</span>
            {/*
            <label>
              <input
                type="checkbox"
                checked={isAllSelected}
                onChange={(e) =>
                  setSelectedRegions(e.target.checked ? REGIONS : [])
                }
              />
              {t("subscription.all")}
            </label>
*/ }
            {REGIONS.map((r) => (
              <label key={r.value}>
                <input
                  type="checkbox"
                  checked={selectedRegions.includes(r.value)}
                  onChange={(e) =>
                    setSelectedRegions((s) =>
                      e.target.checked
                        ? [...s, r.value]
                        : s.filter((x) => x !== r.value)
                    )
                  }
                />
                {r.label}
              </label>
            ))}
          </div>
        </div>

        {/* Language switcher */}
        <div className="input-with-icon">
          <span className="input-icon">
            <FaLanguage />
          </span>
          <select
            value={i18n.language}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
          >
            <option value="en">English</option>
            <option value="es">Español</option>
          </select>
        </div>

        <button type="submit" className="subscribe-btn">
          <FaBell />
          <span>{t("subscription.send")}</span>
        </button>


        {status === "success" && (
          <p className="success">{t("subscription.success")}</p>
        )}
        {status === "error" && (
          <p className="error">{errorMessage}</p>
        )}
      </form>
    </section>
  );
}
